import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import axios from 'axios';
import { toast } from 'react-toastify';

// Add some global styles for the profile page
import { CssBaseline } from '@mui/joy';

// Configure global axios interceptor for 401 errors (session expired)
axios.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if (error.response && error.response.status === 401) {
      // Token expired or unauthorized
      const storedAuthState = sessionStorage.getItem("authLocalstorage");
      if (storedAuthState) {
        // Afficher l'alerte de session expirée
        toast.error("⏰ Votre session a expiré. Veuillez vous reconnecter.", {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        
        // Nettoyer la session
        sessionStorage.removeItem('authLocalstorage');
        
        // Rediriger vers la page de connexion après un court délai
        setTimeout(() => {
          window.location.href = '/';
        }, 2000);
      }
    }
    return Promise.reject(error);
  }
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <CssBaseline />
    <App />
  </React.StrictMode>
);
